import {Injectable} from '@angular/core';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {Observable} from 'rxjs';
import {deserialize, serialize} from '@tisa-group/cdk/json-api';
import {UmpireSponsor} from '@tisa-group/models';
import {
  CrudService,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
} from '@tisa-group/cdk';

@Injectable()
export class SponsorService implements CrudService<UmpireSponsor> {
  constructor(readonly http: TisaUmpireHttpService) {}

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpireSponsor[]>> {
    return this.http
      .get('/sponsors', {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireSponsor>> {
    return this.http
      .get(`/sponsors/${fetchIdentifier}`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  delete(id: string): Observable<void> {
    return this.http.delete(`/sponsors/${id}`);
  }

  create(
    body: Partial<UmpireSponsor>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireSponsor>> {
    return this.http
      .post('/sponsors', serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  update(
    body: Partial<UmpireSponsor>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireSponsor>> {
    return this.http
      .patch<JsonApiResponse<UmpireSponsor>>(
        `/sponsors/${body.id}`,
        serialize({stuff: body}),
        {
          params: objectToHttpParams(params),
        },
      )
      .pipe(deserialize());
  }
}
